export default "__VITE_ASSET__BqMnglXR__"